import Keycloak from 'keycloak-js'
import { getEnv } from '@/utils/helpers'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: getEnv('VITE_KEYCLOAK_SERVER_URL')!,
  realm: getEnv('VITE_KEYCLOAK_REALM')!,
  clientId: getEnv('VITE_KEYCLOAK_CLIENT_ID')!,
})

export default keycloak
